import materialLookup from '../static/Materials.json'

/**
 * Returns an entry of material data matching that material name
 * matName: material name
 */
export default function materialDataLookup(matName) {
    let result;
    materialLookup.forEach((entry) => {
        // console.log(`entry: ${JSON.stringify(entry)}, matName: ${matName}`)
        if(entry.name === matName)
        result =  entry;
        
        return result;
        });
    // console.log(result);
    return result;
    }